import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Wanjinyou-index-1992f2b7abb70b0f3-1'),
    routerUrl: '/Wanjinyou',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Wanjinyou')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Wanjinyou-index-1992f2b7abb70b0f3-2'),
        routerUrl: '/WanjinyouForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./WanjinyouForm')),
      },
      //$MORE$
    ],
  },
];
